var $28b0fbf00803a68f$exports = {};
$28b0fbf00803a68f$exports = {
  "help": "Aide",
  "info": "Informations"
};
export { $28b0fbf00803a68f$exports as default };